var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-cell-group',{staticClass:"mt10"},_vm._l((_vm.searchTypeList),function(item,i){return _c('van-cell',{key:i,attrs:{"title":item.name,"is-link":"","to":"/material/index","value":"新增物料或产品"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }